// Computed column names in binned tables (heatmap, histogram)
export const COUNT = 'count'
export const X_MAX = 'xMax'
export const X_MIN = 'xMin'
export const Y_MAX = 'yMax'
export const Y_MIN = 'yMin'

// Computed column names mapped to group aesthetics
export const FILL = '__fill'
export const LINE_COUNT = 'lines'
export const SERIES = 'series'
export const DISPLAY_NAME = 'displayName'
export const STACKED_LINE_CUMULATIVE = 'cumulative'
export const SYMBOL = '__symbol'
export const TIME = '_time'
export const VALUE = '_value'

// Band Chart's most important column key
export const LOWER = 'lower'
export const MAX = 'max'
export const MIN = 'min'
export const RESULT = 'result'
export const UPPER = 'upper'
